import {
  browserPrivacyControlsRepository,
  TELEMETRY_NOTICE_VERSION,
  telemetryConsentDecision,
} from "./privacy-controls.js";
import { decodeTelemetrySelection } from "./telemetry-selection-contract.js";

const GLOBAL_KEY = "__fishystuffTelemetryConsent";

if (globalThis[GLOBAL_KEY] === undefined) {
  Object.defineProperty(globalThis, GLOBAL_KEY, {
    configurable: false,
    enumerable: false,
    writable: false,
    value: Object.freeze({
      decodeSelection: decodeTelemetrySelection,
      decision(state, defaultMode) {
        return telemetryConsentDecision(state, defaultMode, TELEMETRY_NOTICE_VERSION);
      },
      repository: browserPrivacyControlsRepository,
    }),
  });
}
